import React from "react";
import { withRouter, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CommonAnalyticsEvent from "../../services/analytics/main/common";
import { useRouteSlug } from "@/hooks";
import { TILE_DATA } from "../../constants";
import Img from "@/components/img";
import RightArrowImg from "../../images/arrow-point-to-right.svg";

const NeedHelpCategoriesMob = () => {
  const routeSlug = useRouteSlug();
  const { t } = useTranslation("needHelp");

  const handleViewAllFaq = category => {
    CommonAnalyticsEvent.viewAllFaq({
      category: t(category?.data || category).toLowerCase()
    });
  };

  return (
    <div className="category_section">
      <h4>{t("topics")}</h4>
      <ul>
        {TILE_DATA.map((category, index) => (
          <li key={category.data}>
            <Link
              to={`/${routeSlug}${category.link}`}
              onClick={() => handleViewAllFaq(category.data)}
            >
              <Img src={category.imgSource} alt="helpIcons" />
              <h5>
                {t(category.data)}
                <Img src={RightArrowImg} alt="helpIcons" />
              </h5>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default withRouter(NeedHelpCategoriesMob);
